import JQuery from "jquery";
import Vue from "vue";
import SecureLS from "secure-ls";
import { currentTimezone } from "@chat/Services/timezoneService";

window._ = require("lodash");
window.Vue = Vue;

try {
    require("./plugins.js");
} catch (e) {}

window.axios = require("axios");

window.jQuery = window.$ = JQuery;

window.ls = new SecureLS({
    encodingType: process.env.MIX_LS_ENCODING_TYPE,
    encryptionSecret: process.env.MIX_LS_ENCRYPTION_SECRET,
    metaKey: process.env.MIX_LS_META_KEY,
});

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

window.axios.defaults.headers.common["language"] = window._locale;

window.axios.defaults.headers.common["timezone"] = ls.get("__timezone")
    ? ls.get("__timezone")
    : currentTimezone();

window.axios.defaults.headers.common["X-CSRF-TOKEN"] =
    document.querySelector('meta[name="csrf-token"]').getAttribute("content") ||
    "";

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

window.Moment = require("moment");
